import React, { useState, useEffect, useContext } from 'react';
import { LogoImage } from '~/shared/components/logoImage';
import CreateAccount from './component/createAccount';
import { MainContext } from '~/context';

import {
  Container,
  LoginBox,
  ImageContainer,
  InputContainer,
  Label,
  Input,
  LoginContainer,
  ButtonLogin,
  ForgetPassword,
  LineContent,
  Text,
  ButtonCreateAccount,
  Backto,
} from './styles';

const PharmacistLogin = () => {
  const [createdAccount, setCreatedAccount] = useState(false);

  const context = useContext(MainContext);
  const { setLoginDisplay } = context;

  useEffect(() => {
    setLoginDisplay(true);
  }, []);

  const validationLogin = () => {
    setCreatedAccount(true);
  };

  return (
    <>
      {createdAccount ? (
        <CreateAccount
          setClose={() => {
            setCreatedAccount(false);
          }}
        />
      ) : (
        <Container>
          <LoginBox>
            <ImageContainer>
              <LogoImage />
            </ImageContainer>
            <LoginContainer>
              <InputContainer>
                <Label>Entre com E-mail ou número do celular</Label>
                <Input
                  type="text"
                  placeholder="Digite seu e-mail ou número do celular"
                  onChange={(event) => {
                    return event;
                  }}
                />
              </InputContainer>
              <InputContainer>
                <Label>Senha</Label>
                <Input
                  type="password"
                  placeholder="Digite sua senha"
                  onChange={(event) => {
                    return event;
                  }}
                />
              </InputContainer>
              <ButtonLogin type="button" onClick={() => {}}>
                ENTRAR
              </ButtonLogin>
              <ForgetPassword href="/receita/forgetPassword">
                Esqueceu sua senha?
              </ForgetPassword>
              <LineContent>
                <Text>Ou</Text>
              </LineContent>
              <ButtonCreateAccount
                type="button"
                onClick={() => validationLogin()}
              >
                CRIAR CONTA
              </ButtonCreateAccount>
              <Backto href="/receita">Voltar para o Início</Backto>
            </LoginContainer>
          </LoginBox>
        </Container>
      )}
    </>
  );
};

export default PharmacistLogin;
